import gateway from '../gateway/gateway'

// Actions
const SET_CUSTOM_FIELDS = 'custom_fields/SET_CUSTOM_FIELDS'

export default function reducer(state = [], { type, customFields }) {
  switch (type) {
    case SET_CUSTOM_FIELDS:
      return [...customFields]
    default:
      return state
  }
}

// Action creators
export function setCustomFields(customFields) {
  return {
    type: SET_CUSTOM_FIELDS,
    customFields,
  }
}

export const getCustomFields = () => dispatch =>
  gateway.customFields.getCustomFields().then(data => {
    dispatch(setCustomFields(data || []))
  })
